/**
 * Track a purchase event when an order is completed
 */
export function trackPurchase(params: {
  value: number;
  orderId: string;
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      value: params.value,
      currency: 'RON',
      content_name: 'Depresia, Superputerea Ta!',
      content_type: 'product',
      content_ids: ['1'],
      order_id: params.orderId
    });
  }
}

/**
 * Track when user initiates checkout
 */
export function trackInitiateCheckout(value: number) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: value,
      currency: 'RON',
      content_name: 'Depresia, Superputerea Ta!',
      content_type: 'product',
      content_ids: ['1']
    });
  }
}

/**
 * Track when user adds product to cart
 */
export function trackAddToCart(value: number) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      value: value,
      currency: 'RON',
      content_name: 'Depresia, Superputerea Ta!',
      content_type: 'product',
      content_ids: ['1']
    });
  }
}

/**
 * Track lead event (e.g., newsletter signup, contact form)
 */
export function trackLead(formType: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Depresia, Superputerea Ta!',
      content_category: formType
    });
  }
}
